import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import './gallery.css';


import Open1 from '../../assets/open1.jpg';
// import Open2 from '../../assets/open2.jpg';
// import Open3 from '../../assets/open3.jpg';
// import Open4 from '../../assets/open4.jpg';
import Open5 from '../../assets/open5.jpg';
import Open6 from '../../assets/open6.jpg';
import Open7 from '../../assets/open7.jpg';
import Open8 from '../../assets/open8.jpg';
import Open9 from '../../assets/open9.jpg';
import Open10 from '../../assets/open10.jpg';
import Open11 from '../../assets/open11.jpg';
import Open12 from '../../assets/open12.jpg';
import Open13 from '../../assets/open13.jpg';
import Open14 from '../../assets/open14.jpg';
import Open15 from '../../assets/open15.jpg';
import Open16 from '../../assets/open16.jpg';
import Open17 from '../../assets/open17.jpg';
import Open18 from '../../assets/open18.jpg';

import Vas1 from '../../assets/vas1.jpg';
import Vas2 from '../../assets/vas2.jpg';
import Vas3 from '../../assets/vas3.jpg';
import Vas4 from '../../assets/vas4.jpg';
import Vas5 from '../../assets/vas5.jpg';
import Vas6 from '../../assets/vas6.jpg';
import Vas7 from '../../assets/vas7.jpg';
import Vas8 from '../../assets/vas8.jpg';
import Vas9 from '../../assets/vas9.jpg';
import Vas10 from '../../assets/vas10.jpg';
import Vas11 from '../../assets/vas11.jpg';
import Vas12 from '../../assets/vas12.jpg';







import Katina1 from '../../assets/katina1.jpg';
import Katina2 from '../../assets/katina2.jpg';
import Katina3 from '../../assets/katina3.jpg';
import Katina4 from '../../assets/katina4.jpg';
import Katina5 from '../../assets/katina5.jpg';
import Katina6 from '../../assets/katina6.jpg';
import Katina7 from '../../assets/katina7.jpg';
import Katina8 from '../../assets/katina8.jpg';
import Katina9 from '../../assets/katina9.jpg';
import Katina10 from '../../assets/katina10.jpg';
import Katina11 from '../../assets/katina11.jpg';
import Katina12 from '../../assets/katina12.jpg';




const sections = [
  {
    title: 'Ehipassiko Buddhist Centre Opening Ceremony - 2025',
    images: [Open1, Open5, Open6, Open7, Open8, Open9, Open10, Open11, Open12, Open13, Open14, Open15, Open16, Open17, Open18],
  }, // Open2, Open3, Open4,
  {
    title: 'Vas Aradhana Ceremony - 2024',
    images: [ Vas1, Vas2, Vas3, Vas4, Vas5, Vas6,  Vas7, Vas8, Vas9, Vas10, Vas11, Vas12],
  },
  {
    title: 'Katina Ceremony - 2024',
    images: [Katina1, Katina2, Katina3, Katina4, Katina5, Katina6, Katina7, Katina8, Katina9, Katina10, Katina11, Katina12 ],
  },

];

const Gallery = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Gallery</h1>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} 
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> 
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};

export default Gallery;



